<template>
    <div class="results-box">
        <h1>Strategic Communication: Consistency</h1>
        
        <p>As a reminder, the final piece of communicating strategically is consistency. Review your selections together below. You can reflect on whether you communicated consistently.</p>
        
        <h2>Final Review for Consistency</h2>
        <p v-html="content"></p>
    </div>
</template>
<script>
    import { mapGetters } from "vuex"

    const _reduce = ( a, b ) => a + "<br><br>" + b
    
    export default{
        name: "ShowSelections",
        computed: {
            ...mapGetters([
                "playerSelections"
            ]),
            content(){
                const selections = this.playerSelections
                const questions = selections.map( a => a[0][0].question )
                return "<p>" + questions.reduce( _reduce ) + "</p>"
            }
        }
    }
</script>